import overrideAccordionStyles from "./Accordion";
import overrideAlertStyles from "./Alert";
import overrideAutocompleteStyles from "./Autocomplete";
import overrideAvatarStyles from "./Avatar";
import overrideBackdropStyles from './Backdrop';
import overrideBadgeStyles from "./Badge";
import overrideButtonStyles from './Button';
import overrideCardStyles from './Card';
import overrideChipStyles from "./Chip";
import overrideDataGridStyles from "./DataGrid";
import overrideDrawerStyles from "./Drawer";
import overrideFormControlStyles from "./FormControl";
import overrideInputStyles from './Input';
import overrideLinkMenu from "./Link";
import overrideLoadingButtonStyles from "./LoadingButton";
import overrideMenuStyles from "./Menu";
import overridePaginationStyles from "./Pagination";
import overridePaperStyles from './Paper';
import overridePopoverStyles from "./Popover";
import overrideProgressStyles from "./Progress";
import overrideSelectStyles from "./Select";
import overrideSvgIconStyles from "./SvgIcon";
import overrideSwitchStyles from "./Switch";
import overrideTabsStyles from "./Tab";
import overrideTableStyles from './Table';
import overrideTooltipStyles from './Tooltip';
import overrideTypographyStyles from './Typography';


const overrideComponents = theme => Object.assign(
	overrideAccordionStyles(theme),
	overrideAlertStyles(theme),
	overrideAutocompleteStyles(theme),
	overrideAvatarStyles(theme),
	overrideBackdropStyles(theme),
	overrideBadgeStyles(theme),
	overrideButtonStyles(theme),
	overrideCardStyles(theme),
	overrideChipStyles(theme),
	overrideDataGridStyles(theme),
	overrideDrawerStyles(theme),
	overrideFormControlStyles(theme),
	overrideInputStyles(theme),
	overrideLinkMenu(theme),
	overrideLoadingButtonStyles(theme),
	overrideMenuStyles(theme),
	overridePaginationStyles(theme),
	overridePaperStyles(theme),
	overridePopoverStyles(theme),
	overrideProgressStyles(theme),
	overrideSelectStyles(theme),
	overrideSvgIconStyles(theme),
	overrideSwitchStyles(theme),
	overrideTabsStyles(theme),
	overrideTableStyles(theme),
	overrideTooltipStyles(theme),
    overrideTypographyStyles(theme)
)

export default overrideComponents;